/**
 * RAO nested routes.
 *
 * - /rao          → dashboard listing my carts
 * - /rao/new      → CartBootstrapStep (opening-officer wizard) → POST /v3/carts
 * - /rao/:cartId  → record page with stage ribbon + steps
 *
 * Everything under RaoRoutes is wrapped in <CartProvider/> so the active
 * CartDto + debounced save live at the RAO-module root; cross-module mounts
 * (RCM, RAM, …) wrap their own providers so they don't share this instance.
 */
import { Routes, Route } from 'react-router';
import { CartProvider } from '@/contexts/CartContext';
import { RaoLanding } from './RaoLanding';
import { CartDetail } from './CartDetail';
import { CartBootstrapStep } from './steps/CartBootstrapStep';

export function RaoRoutes(): JSX.Element {
  return (
    <CartProvider>
      <Routes>
        <Route index element={<RaoLanding />} />
        <Route path="new" element={<CartBootstrapStep />} />
        <Route path=":cartId" element={<CartDetail />} />
        <Route path="*" element={<RaoLanding />} />
      </Routes>
    </CartProvider>
  );
}
